/*eslint-disable */
import React, { useEffect, FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "Utils/router";

import TourStore from "./store";
import YouvisitAnalyticsStore from "../YouVisitAnalytics/store";
import PageLoader from "Components/loader/pageLoader";
import { GeneralError } from "Components/helpers";
import { IRootState } from "../../../store/rootState";

const URI = require("urijs");

/**
 * Generate Initial Tour Model
 * - be explicit with keys
 */
const getInitializeParamsFromUrl = (
  props: any,
  routeLocation: any
): { tourModel: any; analyticsModel: any } => {
  const hasSearch =
    window.location.hash.indexOf("?") > 0
      ? window.location.hash.split("?")[1]
      : "";

  // The linter prefers this way, instead of nested conditionals
  let search = window.location.search ? window.location.search : hasSearch;
  search = routeLocation.search ? routeLocation.search : search;

  // Traditional RouteParams are not loaded at this time, so we have to do it ourselves
  const routeParams = routeLocation.pathname.split("/");
  const urlParams = URI.parseQuery(search);
  const { instId, locId, tourId: defaultTourId } = props;
  let { source } = urlParams;
  if (!source) source = "web";
  let platform = urlParams.source;
  if (!platform && urlParams.pl) platform = urlParams.pl;
  if (!platform && urlParams.platform) platform = urlParams.platform;
  if (!platform) platform = "w";
  let { originalSource } = urlParams;
  if (!originalSource) originalSource = urlParams.original_source;
  if (!originalSource && source) originalSource = source;
  let title = null;
  if (!title) title = urlParams.title;
  let fromSearch = null;
  if (!fromSearch) fromSearch = urlParams.fromSearch;

  // This will set the value of standalone.  It takes into account null, undefined, a numeric string and a number.
  const isStandalone = !!(
    urlParams.standalone === "true" ||
    urlParams.standalone === "1" ||
    urlParams.standalone === 1
  );

  // TODO: Move use redux....
  const tourModel = {
    instId,
    locId,
    tourid: urlParams.tourid || urlParams.tourId || defaultTourId,
    platform,
    onCampus: urlParams.oncampus ? urlParams.oncampus : false,
    isHover: urlParams.isHover,
    isStandalone,
    title,
    fromSearch,
    isLoading: false,
    linkParams: {
      stopid: urlParams.loc || null,
      media: urlParams.media || null,
    }
  };

  const analyticsModel = {
    userkey: urlParams.userkey ? urlParams.userkey : urlParams.userKey,
    sessionId: urlParams.sessionid ? urlParams.sessionid : "0",
    source,
    originalSource,
    isReady: true,
  };

  return { tourModel, analyticsModel };
};

interface Props {
  children: any;
  instId: string | number;
  locId: string;
}

const TourInitializer: FC<any> = (props: Props) => {
  const dispatch = useDispatch();
  const routeLocation = useLocation();
  const tourModel = useSelector((state: IRootState) => state.tour);
  useEffect(() => {
    const data = getInitializeParamsFromUrl(props, routeLocation);
    dispatch(TourStore.actions.initializeTourWithParams(data.tourModel));
    if (!data.tourModel.isStandalone) {
      // if standalone we should init based on passed params
      dispatch(
        YouvisitAnalyticsStore.actions.setYouVisitAnalyticsConfig({
          isReady: true,
          analytics: data.analyticsModel,
        })
      );
    }
  }, [routeLocation, props.instId, props.locId]);
  // Are we still parsing data to set redux?
  if (tourModel.isLoading) return <PageLoader />;
  if (!tourModel.instId)
    return <GeneralError message="Failed to initialize form configuration." />;
  return props.children;
};

export default TourInitializer;
try {
    // @ts-ignore
    TourInitializer.displayName = "TourInitializer";
    // @ts-ignore
    TourInitializer.__docgenInfo = { "description": "", "displayName": "TourInitializer", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/TourInitializer/TourInitializer.tsx#TourInitializer"] = { docgenInfo: TourInitializer.__docgenInfo, name: "TourInitializer", path: "src/shared/hoc/TourInitializer/TourInitializer.tsx#TourInitializer" };
}
catch (__react_docgen_typescript_loader_error) { }